module.exports = __webpack_public_path__ + "img/person.becf0252.svg";